import { CompFabCore } from '../core/fab/comp'

export const CompFab = CompFabCore
